// hooks/useScheduledReportsListData.ts
import { getScheduledReports } from '@api/services/analytics.service';
import useDataQuery from '@hooks/use-data-query';
import { useMemo } from 'react';

const useScheduledReportsListData = (startDate: string, endDate: string) => {
    const query = useDataQuery(['scheduled-reports', startDate, endDate], () =>
        getScheduledReports(startDate, endDate)
    );

    const data = useMemo(() => query.data || [], [query.data]);

    return {
        data,
        isLoading: query.isLoading,
    };
};

export default useScheduledReportsListData;
